import React, { useEffect, useState } from "react";
import { Container, WalletHeader, BalanceCard, SummaryCards, SummaryCard, Transactions, TransactionItem } from "./styled";
import { useHomeChefById } from "../useHook";

interface WalletsProps {
  homeCookId: string;
}
const Wallets = ({ homeCookId }: WalletsProps) => {
    const [data, setData] = useState<any>(null);
    const { getWalletStats } = useHomeChefById();
   console.log(data, "data");
   
    useEffect(() => {
       getWalletStats(homeCookId, setData); 
    },[homeCookId])
  return (
    <Container>
      {/* Header */}
      <WalletHeader>
        <h1>Wallet</h1>
      </WalletHeader>

      {/* Balance Card */}
      {/* <BalanceCard>
        <div className="balance-info">
          <p className="label">Available Balance</p>
          <h2>$100</h2>
          <p className="name">Chef Name</p>
        </div>
      </BalanceCard> */}

      {/* Summary Section */}
      <SummaryCards>
         <SummaryCard bg="#E8F0FF">
          <p>Total</p>
          <h3>${data?.totalBalance || 0}</h3>
        </SummaryCard>
        <SummaryCard bg="#E8F0FF">
          <p>Available</p>
          <h3>${data?.totalAvailable || 0}</h3>
        </SummaryCard>
        <SummaryCard bg="#E4F8F0">
          <p>Pending</p>
          <h3>${data?.totalPending || 0}</h3>
        </SummaryCard>
        <SummaryCard bg="#FCECEC">
          <p>Penalty</p>
          <h3>${data?.totalPenalty || 0}</h3>
        </SummaryCard>
          <SummaryCard bg="#FCECEC">
          <p>Withdraw</p>
          <h3>Coming Soon</h3>
        </SummaryCard>
      </SummaryCards>

      {/* Transactions */}
      <Transactions>
        <div className="header">
          <h2>Transactions</h2>
          {/* <span className="see-all">See All</span> */}
        </div>

        <TransactionItem>
          <div>
            <p className="title">Withdrawn from wallet</p>
            <p className="date">10 Jul 2025</p>
          </div>
          <p className="amount red">$50</p>
        </TransactionItem>

        <TransactionItem>
          <div>
            <p className="title">Withdrawn from wallet</p>
            <p className="date">10 Jul 2025</p>
          </div>
          <p className="amount red">$50</p>
        </TransactionItem>

        <TransactionItem>
          <div>
            <p className="title">Withdrawn from wallet</p>
            <p className="date">10 Jul 2025</p>
          </div>
          <p className="amount red">$50</p>
        </TransactionItem>
      </Transactions>
    </Container>
  );
};

export default Wallets;
